module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-dash-cb3b6ae2.svg";